import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AlertPerson {
  name: string | null;
  gmid: string | null;
  email: string | null;
  photo: string | null;
}

export interface AlertData {
  title?: string;
  message: string;
  details?: string;
  confirmText?: string;
  cancelText?: string;
  isConfirm?: boolean;
  person?: AlertPerson;
}

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  standalone: false
})
export class AlertComponent {
  constructor(
    public dialogRef: MatDialogRef<AlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AlertData
  ) {
    // Set default values
    this.data.title = this.data.title || (this.data.isConfirm ? 'Confirm' : 'Alert');
    this.data.confirmText = this.data.confirmText || (this.data.isConfirm ? 'Yes' : 'OK');
    this.data.cancelText = this.data.cancelText || 'No';
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onClose(): void {
    this.dialogRef.close(this.data.isConfirm ? false : true);
  }
}
